import { createContext } from "react";

export const WeatherDashboardContext = createContext<
  { icao: string } | undefined
>(undefined);
